module.exports = __webpack_public_path__ + "img/RupiahUpIcon.3b195cc6.svg";